import React, {Suspense, lazy} from 'react';

const TheDropdown = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */'./TheDropdown'));

const Dropdown = (props) => {
    return <Suspense fallback={null}>
        <TheDropdown {...props} />
    </Suspense>
}

export default Dropdown;
